function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1444,
  height: 801,
  x: 532,
  y: 1589,
  fill: "#3E364A"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 633.5,
  cy: 1612.576,
  r: 633.5,
  fill: "#66656C"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1595,
  height: 1488,
  x: 813,
  y: 345,
  fill: "#999F99",
  transform: "rotate(43 1610.5 1089)"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FEFAC7",
  points: "1338 1527 1708 2007 968 2007"
}));

const SvgShapes = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2702,
    height: 2390,
    viewBox: "0 0 2702 2390",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShapes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shapes.f0b6bb81.svg";
export { ForwardRef as ReactComponent };